export function toTitleCaseFromSnakeCase(str) {
    str = str.replace('_',' ').toLowerCase();
    return str.replace(/\b\S/g, function (txt) {
        return txt.charAt(0).toUpperCase();
    });
}